<template>
  <div id='bd-kb-aside'>
    <span>第三方应用</span>
  </div>
</template>

<script>
// import { mapActions, mapGetters } from 'vuex'
// import * as https from '@/apis/http'
// import bus from '@/util/eventbus'
const constants = require('@/util/constants')

export default {
  name: 'bd-kb-aside',
  data () {
    return {
    }
  },
  computed: {
    // ...mapGetters([ 'userCurrentkb', 'userkbs' ]),
  },
  methods: {
    //
  },
  created () {
    //
  },
  mounted() {
    
  },
  filters: {
    // 将日期过滤为 hour:minutes
    time (value) {
      if (typeof value === 'string') {
        return moment(value).format('MM-DD HH:mm:ss')
      } else {
        return value
      }
    }
  }
}
</script>

<style scoped>
#bd-kb-aside {
  width: 100%;
  height: 100%;
  float: left;
}
</style>
